import { Injectable, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/** Misma clave que el script de index.html, para no parpadear al cargar. */
const STORAGE_KEY = 'mayorap_theme';
const DARK_CLASS = 'app-dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly router = inject(Router);
  readonly oscuro = signal(this.leer());

  constructor() {
    this.aplicar(this.oscuro());
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.aplicar(this.oscuro()));
  }

  alternar(): void {
    const siguiente = !this.oscuro();
    this.oscuro.set(siguiente);
    this.aplicar(siguiente);
    localStorage.setItem(STORAGE_KEY, siguiente ? 'dark' : 'light');
  }

  private leer(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'dark';
    } catch {
      return false;
    }
  }

  private esInicio(): boolean {
    const path = this.router.url.split('?')[0].replace(/\/$/, '') || '/';
    return path === '/';
  }

  private aplicar(oscuro: boolean): void {
    document.documentElement.classList.toggle(DARK_CLASS, oscuro && !this.esInicio());
  }
}
